import { http } from "../../../common/http";
import { NewsParam } from "../param/news.param";

class NewsService {
	list = (params: NewsParam) => {
		return http({
			method: "GET",
			url: "/news",
			params
		});
	};

	detail = (id: number) => {
		return http({
			method: "GET",
			url: `/news/${id}`,
		});
	};
}
export default new NewsService();
